<template>
  <div>
    <h1>Documento Nº {{ formHeader.documentNumber }} <b-badge>(PREVISUALIZACION)</b-badge></h1>
    <h5>
      Fecha de emisión: <b-badge variant="dark">{{ formHeader.documentDate | date }}</b-badge>
    </h5>

    <b-table-simple fixed>
      <b-tbody>
        <b-tr>
          <b-td>
            <b>{{ formHeader.documentClientCustomer.text }}</b> <br />
            <b>Emisor:</b> <br />
            {{ formHeader.documentSenderCompany.company_name }}<br />
            {{ formHeader.documentSenderCompany.company_number }}<br />
            {{ formHeader.documentSenderCompany.address1 }}<br />
            {{ formHeader.documentSenderCompany.address2 }}<br />
          </b-td>
          <b-td class="text-right">
            <b> </b> <br />
            <b>Recibidor</b> <br />
            {{ formHeader.documentRecipientCompany.company_name }}<br />
            {{ formHeader.documentRecipientCompany.company_number }}<br />
            {{ formHeader.documentRecipientCompany.address1 }}<br />
            {{ formHeader.documentRecipientCompany.address2 }}<br />
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <b-table-simple fixed>
      <b-tbody>
        <b-tr>
          <b-td>
            <b> <u> Detalles</u></b> <br />
            Nombre Chofer: {{ formHeader.documentTruckDriver }}<br />
            Rut Chofer: {{ formHeader.documentTruckDriverRut }}<br />
            Patente: {{ formHeader.documentLicensePlate }}<br />
          </b-td>
          <b-td>
            <b> <u> </u></b> <br />
            Sucursal: {{ formHeader.sucursal }}<br />
            Traslado: {{ formHeader.traslado }}<br />
            Despacho: {{ formHeader.despacho }}<br />
          </b-td>
          <b-td>
            <b> <u> </u></b> <br />
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <b-form-group>
      <label class="font-weight-bold" for="name">Nota del documento</label>
      <b-form-textarea
        autocomplete="off"
        type="text"
        size="sm"
        v-model="formHeader.documentNote"
        id="name"
        placeholder="Ingrese la nota del documento"
      />
    </b-form-group>
    <b-table hover small foot-clone :items="items" :fields="fields">
      <template #cell(codigo)="data">
        <label-form :item="data.item" variant="dark" modalName="labelForm2" />
        {{ data.item.codigo }}
      </template>
      <template #cell(subtotal)="data">{{ data.item.subtotal | currency }}</template>
      <template #foot()="data"><span></span></template>
      <template #foot(unitario)="data"
        ><span class=""
          >Total Neto <br />
          IVA <br />
          Total</span
        ></template
      >
      <template #foot(subtotal)="data"
        >{{ total | currency }} <br />
        {{ (total * 0.19) | currency }} <br />
        {{ (total * 1.19) | currency }}</template
      >
    </b-table>
  </div>
</template>

<script>
import LabelForm from "./LabelForm.vue";
import moment from "moment";

var formatter = new Intl.NumberFormat("es-CL", {
  style: "currency",
  currency: "CLP"
});
export default {
  components: { LabelForm },
  props: {
    formHeader: {
      type: Object,
      default: () => {}
    },
    items: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      default: () => [
        {
          key: "codigo",
          label: "Codigo"
        },
        {
          key: "descripcion",
          label: "Descripción"
        },
        {
          key: "cantidad",
          label: "Cantidad"
        },
        {
          key: "unitario",
          label: "Unitario"
        },
        {
          key: "subtotal",
          label: "Subtotal",
          class: ["text-right"]
        }
      ]
    }
  },
  filters: {
    currency(value) {
      return formatter.format(value);
    },
    date(value) {
      return moment(value).format("DD/MM/YYYY");
    }
  },
  computed: {
    total() {
      return this.items.reduce((total, item) => total + item.subtotal, 0);
    }
  }
};
</script>

<style></style>
